module.exports = __webpack_public_path__ + "img/founders_01.0ce684c4.jpg";